<template>
  <!-- TOAST LOADING -->
  <div class="MIDAS-TOAST-loading" v-if="isLoading">
    <i class="MIDAS-TOAST-loading__icon icon-load"></i>
    <p class="MIDAS-TOAST-loading__txt">{{ loadingMsg ? loadingMsg : "加载中，请稍候..."}}</p>
  </div>
</template>
<script>
export default {
  name: "Loading",
  props: ["isLoading", "loadingMsg"]
}
</script>

<style scoped>
.MIDAS-TOAST-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 1071;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 1.5em 2em;
  color: #fff;
  font-size: 0.28rem;
  white-space: nowrap;
  border-radius: 0.5em;
}
.MIDAS-TOAST-loading__icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  background-image: url("../../../../ui/LianPoH5/images/icon-load.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  vertical-align: -6px;
  background-position: center;
  -webkit-animation: MIDAS-MOBILD-ani_loading linear 0.6s infinite;
  animation: MIDAS-MOBILD-ani_loading linear 0.6s infinite;
}
.MIDAS-TOAST-loading__txt {
  line-height: 1;
  display: inline-block;
}
@-webkit-keyframes MIDAS-MOBILD-ani_loading {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes MIDAS-MOBILD-ani_loading {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
